import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserState } from 'src/app/store/user.state';
import { AppService } from '../../../services/app.service';
import { AsyncPipe } from '@angular/common';
import { NavigationService } from '../../../services/navigation.service';
import { Router } from '@angular/router';
import { ProductTourService } from '../../../services/product-tour.service';
import { FlagsState } from '../../../store/flags.state';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrl: './header-mobile.component.scss',
  imports: [TranslateModule, AsyncPipe],
})
export class HeaderMobileComponent {
  @Input() showBackButton: boolean = true;
  @Input() customTitle?: string;
  @Input() showAvatar: boolean = true;

  @Output() navigateBack = new EventEmitter<void>();

  constructor(
    public userState: UserState,
    public appService: AppService,
    public flagsState: FlagsState,
    public productTourService: ProductTourService,
    private navigationService: NavigationService,
    private router: Router,
  ) {}

  goTo(route: string): void {
    if (this.router.url === '/onboarding') {
      return;
    }

    void this.navigationService.navigateRoot(route);
  }

  async startHomeTour(): Promise<void> {
    if (this.router.url !== '/home') {
      await this.navigationService.navigateRoot('/home');
    }

    void this.productTourService.startTour();
  }
}
